module.exports = __webpack_public_path__ + "img/DirectionsBusFilledOutlined.b50594af.svg";